import { useContext } from 'react';
import { Buttons, FlexContainer, ModalContext, Modals, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import useTranslation from 'Hooks/useTranslation';
import { openLinkInNewTab } from 'Utils/links';
import { routes } from 'Constants/routes';
import { E_FIRMA, RECOVER_PASSWORD, VIDEO_LINK } from './utils';
import * as Styled from './styles';

const DgModal = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);
  const { hideModal } = useContext(ModalContext);
  const handleClick = (route: string): void => {
    setTimeout(() => {
      openLinkInNewTab(route);
    }, 100);
  };

  const tinyButtonClick = (): void => {
    history.push(routes.DATAGATHERING_HELP);
    hideModal();
  };

  return (
    <Modals.Centered maxSize="M" hasClose onClose={hideModal}>
      <Styled.ModalContent direction="column" gap="dimension_16">
        <Text type="paragraphs" color="dark" size="XL_XL_S" align="center">
          {t('Dg.modal.title')}
        </Text>
        <Text type="paragraphs" color="grey" size="S_M_S" align="center">
          {t('Dg.modal.subtitle')}
        </Text>
        <Styled.OptionsContainer direction="column" align="center" gap="dimension_16">
          <Styled.OptionCard
            direction="column"
            align="flex-start"
            justify="flex-start"
            gap="dimension_16"
          >
            <Text type="paragraphs" color="dark" size="M_L_S">
              {t('Dg.firstStep.password.title')}
            </Text>
            <FlexContainer direction="column" align="flex-start" gap="dimension_08">
              <div>
                <Text type="paragraphs" color="dark" size="S_M_S">
                  {t('Dg.modal.efima')}
                </Text>
              </div>
              <Buttons.Contextual
                mode="secondary"
                label={t('Dg.modal.efima.button')}
                onClick={() => handleClick(E_FIRMA)}
              />
            </FlexContainer>
          </Styled.OptionCard>
          <Styled.OptionCard
            direction="column"
            align="flex-start"
            justify="flex-start"
            gap="dimension_16"
          >
            <Text type="paragraphs" color="dark" size="M_L_S">
              {t('Dg.secondStep.password.title')}
            </Text>
            <FlexContainer direction="column" align="flex-start" gap="dimension_08">
              <div>
                <Text type="paragraphs" color="dark" size="S_M_S">
                  {t('Dg.modal.recover')}
                </Text>
              </div>
              <Buttons.Contextual
                mode="secondary"
                label={t('Dg.modal.recove.password')}
                onClick={() => handleClick(RECOVER_PASSWORD)}
              />
            </FlexContainer>
          </Styled.OptionCard>
          <Styled.OptionCard
            direction="column"
            align="flex-start"
            justify="flex-start"
            gap="dimension_16"
          >
            <div>
              <Text type="paragraphs" color="dark" size="XS_S_S">
                {t('Dg.modal.video')}
              </Text>
            </div>
            <Styled.ContentVideo>
              <Styled.Video
                src={VIDEO_LINK}
                title="password_video"
                frameborder="0"
                allowFullScreen
              />
            </Styled.ContentVideo>
          </Styled.OptionCard>
        </Styled.OptionsContainer>
        <Buttons.Tiny label={t('Dg.calculate.notification.title')} onClick={tinyButtonClick} />
      </Styled.ModalContent>
    </Modals.Centered>
  );
};

export default DgModal;
